import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useBrandQuery } from "@saleor/collections/queries";
import ActionDialog from "@saleor/components/ActionDialog";
import AssignCustomerDialog from "@saleor/components/AssignCustomerDialog";
// import AssignCategoriesDialog from "@saleor/components/AssignCategoryDialog";
// import AssignCollectionDialog from "@saleor/components/AssignCollectionDialog";
import AssignDiscountProductDialog from "@saleor/components/AssignDiscountProductDialog";
import AssignMallDialog from "@saleor/components/AssignMallDialog";
import BrandGroupDialog from "@saleor/components/BrandGroupDialog";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { DEFAULT_INITIAL_SEARCH_DATA, PAGINATE_BY } from "@saleor/config";
import AssignProductSubsidyDialog from "@saleor/discounts/components/AssignProductSubsidyDialog";
import BrandSingleEditDialog from "@saleor/discounts/components/BrandSingleEditDialog";
import useVoucherLimitsData, {
  initializeVoucherCondition,
  IVoucherCondition
} from "@saleor/discounts/hooks/useVoucherLimitsData";
import { VoucherAddBrandGroups } from "@saleor/discounts/types/VoucherAddBrandGroups";
import { VoucherCustomersAdd } from "@saleor/discounts/types/VoucherCustomersAdd";
import { VoucherCustomersRemove } from "@saleor/discounts/types/VoucherCustomersRemove";
import { VoucherMallsAdd } from "@saleor/discounts/types/VoucherMallsAdd";
import { VoucherMallsRemove } from "@saleor/discounts/types/VoucherMallsRemove";
import { VoucherTenantDelete } from "@saleor/discounts/types/VoucherTenantDelete";
import { VoucherTenantUpdate } from "@saleor/discounts/types/VoucherTenantUpdate";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
import useShop from "@saleor/hooks/useShop";
import { sectionNames } from "@saleor/intl";
import useBrandGroupSearch from "@saleor/searches/useBrandGroupSearch";
import useCustomerSearch from "@saleor/searches/useCustomerSearch";
import useMallQuery from "@saleor/searches/useMallQuery";
// import useCategorySearch from "@saleor/searches/useCategorySearch";
// import useCollectionSearch from "@saleor/searches/useCollectionSearch";
import useProductSearch from "@saleor/searches/useProductSearch";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { changeTimeZone } from "@saleor/utils/smop/changeTimeZoneDateTime";
import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

// import { categoryUrl } from "../../categories/urls";
// import { collectionUrl } from "../../collections/urls";
import { decimal, maybe } from "../../../misc";
// import { productUrl } from "../../../products/urls";
import {
  DiscountStatusEnum,
  DiscountValueTypeEnum,
  LockStatus,
  SmopStatusEnum,
  // VoucherCatalogueInput,
  VoucherDiscountType,
  VoucherTypeEnum
} from "../../../types/globalTypes";
// import AssignProductDialog from "../../components/AssignProductDialog";
// import DiscountCountrySelectDialog from "../components/DiscountCountrySelectDialog";
import VoucherDetailsPage, {
  VoucherDetailsPageFormData,
  VoucherDetailsPageTab
} from "../../components/VoucherDetailsPage";
import {
  TypedUpdateVoucherStatus,
  TypedVoucherAddBrandGroups,
  TypedVoucherCataloguesAdd,
  TypedVoucherCataloguesRemove,
  TypedVoucherCustomersAdd,
  TypedVoucherCustomersRemove,
  TypedVoucherMallsAdd,
  TypedVoucherMallsRemove,
  TypedVoucherTenantDelete,
  TypedVoucherTenantUpdate,
  TypedVoucherUpdate
} from "../../mutations";
import {
  useVoucherBrandGroupsDetail,
  useVoucherCustomerDetails,
  useVoucherDetails,
  useVoucherProductDetails,
  useVoucherVariantDetails
} from "../../queries";
import { RequirementsPicker } from "../../types";
import { UpdateVoucherStatus } from "../../types/UpdateVoucherStatus";
import { VoucherCataloguesAdd } from "../../types/VoucherCataloguesAdd";
import { VoucherCataloguesRemove } from "../../types/VoucherCataloguesRemove";
import { VoucherUpdate } from "../../types/VoucherUpdate";
import {
  bulkVoucherListUrl,
  voucherListUrl,
  voucherUrl,
  VoucherUrlDialog,
  VoucherUrlQueryParams
} from "../../urls";
import {
  createCustomerPaginationState,
  createMallsPaginationState,
  createProductPaginationState,
  customerPaginate,
  mallsPaginate,
  productPaginate
} from "./utils";
interface VoucherDetailsProps {
  id: string;
  params: VoucherUrlQueryParams;
}

export const DEFAULT_INITIAL_SEARCH_PRODUCT_DATA = {
  after: null,
  first: 20,
  query: ""
};

export const VoucherDetails: React.FC<VoucherDetailsProps> = ({
  id,
  params
}) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const notify = useNotifier();
  const shop = useShop();

  // const [currentType, setCurrentType] = React.useState(null);
  const [eligibleStoreInfo, setStoreInfo] = React.useState(null);
  const [currentBrand, setCurrentBrand] = React.useState(null);

  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const intl = useIntl();
  // const {
  //   loadMore: loadMoreCategories,
  //   search: searchCategories,
  //   result: searchCategoriesOpts
  // } = useCategorySearch({
  //   variables: DEFAULT_INITIAL_SEARCH_DATA
  // });
  // const {
  //   loadMore: loadMoreCollections,
  //   search: searchCollections,
  //   result: searchCollectionsOpts
  // } = useCollectionSearch({
  //   variables: DEFAULT_INITIAL_SEARCH_DATA
  // });

  const {
    loadMore: loadMoreMalls,
    search: searchMall,
    result: searchMallsOpts
  } = useMallQuery({
    variables: {
      after: null,
      first: 100,
      query: "",
      statuses: [SmopStatusEnum.ACT]
    }
  });

  const {
    loadMore: loadMoreCustomers,
    result: searchCustomerOpts,
    search: searchCustomers
  } = useCustomerSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      status: LockStatus.ACTIVE
    }
  });

  const {
    voucherLimitDispatcher,
    voucherLimitState,
    voucherConditionUpdate
  } = useVoucherLimitsData();

  const paginationState = createPaginationState(100, params);
  const mallsPaginationState = createMallsPaginationState(100, params);
  const productPaginationState = createProductPaginationState(
    PAGINATE_BY,
    params
  );

  const customerPaginationState = createCustomerPaginationState(
    PAGINATE_BY,
    params
  );

  const changeTab = (tab: VoucherDetailsPageTab) => {
    reset();
    navigate(
      voucherUrl(id, {
        activeTab: tab
      })
    );
  };

  const { data, loading, refetch } = useVoucherDetails({
    displayLoader: true,
    variables: {
      id,
      ...mallsPaginationState
    }
  });

  const voucherDetails = data;

  const currentCode = data?.voucher?.code;

  const brandInitialSearchData = {
    after: null,
    first: 20,
    query: "",
    status: SmopStatusEnum.ACT
  };

  const {
    loadMore: loadMoreBrand,
    search: searchBrands,
    result: brandsQueryData
  } = useBrandQuery({
    variables: {
      ...brandInitialSearchData,
      malls: data && data.voucher.malls.edges.map(edges => edges.node.id)
    }
  });

  const sellerBrandChoices = maybe(
    () => brandsQueryData?.data?.search?.edges,
    []
  ).map(edge => edge.node);

  const {
    loadMore: loadMoreProducts,
    search: searchProducts,
    result: searchProductsOpts
  } = useProductSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_PRODUCT_DATA,
      brands: currentBrand ? [currentBrand] : [],
      malls: data && data.voucher.malls.edges.map(edges => edges.node.id)
    }
  });

  const {
    data: productData,
    refetch: productRefetch
  } = useVoucherProductDetails({
    displayLoader: true,
    skip:
      data === undefined ||
      (data && data.voucher.type === "E_VOUCHER") ||
      data.voucher.discountValueType === DiscountValueTypeEnum.PERCENTAGE ||
      data.voucher.discountValueType === DiscountValueTypeEnum.FIXED,
    variables: {
      id,
      ...productPaginationState
    }
  });

  const [voucherProductQuery, setvoucherProductQuery] = React.useState("");

  const {
    data: variantData,
    refetch: variantRefetch
  } = useVoucherVariantDetails({
    displayLoader: true,
    // skip:
    //   data &&
    //   data.voucher.type !== "E_VOUCHER" &&
    //   data.voucher.discountValueType !== DiscountValueTypeEnum.PERCENTAGE,
    variables: {
      id,
      query: voucherProductQuery,
      ...productPaginationState
    }
  });

  const {
    data: customerData,
    refetch: customerRefetch
  } = useVoucherCustomerDetails({
    displayLoader: true,
    variables: {
      id,
      ...customerPaginationState
    }
  });

  const {
    data: storesData,
    refetch: storesRefetch
  } = useVoucherBrandGroupsDetail({
    displayLoader: true,
    variables: {
      id
    }
  });

  useEffect(() => {
    if (!loading && !!data) {
      const ongoingOrderDetails = data.voucher.voucherConditions.edges.find(
        val => val.node.metric === "COMPLETED_ORDER"
      );
      const reshapedOngoingOrderDetails: IVoucherCondition =
        ongoingOrderDetails !== undefined
          ? {
              operation: ongoingOrderDetails.node.operation,
              value: ongoingOrderDetails.node.value
            }
          : initializeVoucherCondition();

      const swipeCouponsDetails = data.voucher.voucherConditions.edges.find(
        val => val.node.metric === "REDEEMED_COUPON"
      );
      const reshapedSwipeCouponDetails: IVoucherCondition =
        swipeCouponsDetails !== undefined
          ? {
              operation: swipeCouponsDetails.node.operation,
              value: swipeCouponsDetails.node.value
            }
          : initializeVoucherCondition();

      const isLimitToCustomerActivity: boolean =
        ongoingOrderDetails !== undefined || swipeCouponsDetails !== undefined;

      voucherLimitDispatcher({
        type: "re-initialize",
        voucherLimitState: {
          isLimitToCustomerActivity,
          isWithOngoingOrders: ongoingOrderDetails !== undefined,
          isWithSwipeCoupons: swipeCouponsDetails !== undefined,
          ongoingOrderVoucherCondition: reshapedOngoingOrderDetails,
          swipeCouponVoucherCondition: reshapedSwipeCouponDetails
        }
      });
    }
  }, [data, loading]);

  const handleUpdateVoucherStatus = (data: UpdateVoucherStatus) => {
    if (data.updateVoucherStatus.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher successfully deactivated."
        })
      });
      navigate(voucherListUrl(), true);
    }
  };

  const handleVoucherUpdate = (data: VoucherUpdate) => {
    if (data.voucherUpdate.errors.length === 0) {
      closeModal();
      refetch();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher Successfully Updated."
        })
      });
    } else if (
      data.voucherUpdate.errors.some(e => e.field === "discountShare")
    ) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "The discount distribution is invalid."
        })
      });
    } else {
      notify({
        status: "error",
        text: data.voucherUpdate.errors[0].message
      });
    }
  };

  const [openModal, closeModal] = createDialogActionHandlers<
    VoucherUrlDialog,
    VoucherUrlQueryParams
  >(navigate, params => voucherUrl(id, params), params);

  const handleCatalogueAdd = (data: VoucherCataloguesAdd) => {
    if (data.voucherCataloguesAdd.errors.length === 0) {
      // if (
      //   data.voucherCataloguesAdd.voucher.type === "E_VOUCHER" ||
      //   data.voucherCataloguesAdd.voucher.discountValueType ===
      //     DiscountValueTypeEnum.PERCENTAGE
      // ) {
      //   variantRefetch();
      // } else {
      //   productRefetch();
      // }
      variantRefetch();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher Updated"
        })
      });
      closeModal();
    } else {
      notify({
        status: "error",
        text: data.voucherCataloguesAdd.errors[0].message
      });
    }
  };

  const handleCatalogueRemove = (data: VoucherCataloguesRemove) => {
    if (data.voucherCataloguesRemove.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher Updated"
        })
      });
      variantRefetch();
      // if (
      //   data.voucherCataloguesRemove.voucher.type === "E_VOUCHER" ||
      //   data.voucherCataloguesRemove.voucher.discountValueType ===
      //     DiscountValueTypeEnum.PERCENTAGE
      // ) {
      //   variantRefetch();
      // } else {
      //   productRefetch();
      // }
    } else {
      notify({
        status: "error",
        text: data.voucherCataloguesRemove.errors[0].message
      });
    }
  };

  const [assignMallShouldNotify, setAssignMallShouldNotify] = React.useState(
    true
  );

  const handleMallsAdd = (data: VoucherMallsAdd) => {
    if (data.voucherAddMalls.errors.length === 0) {
      closeModal();
      reset();
      if (assignMallShouldNotify) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Voucher Updated"
          })
        });
        refetch();
      }
      if (data.voucherAddMalls.voucher.type === "E_VOUCHER") {
        variantRefetch();
      } else {
        productRefetch();
      }
    } else {
      if (assignMallShouldNotify) {
        notify({
          status: "error",
          text: data.voucherAddMalls.errors[0].message
        });
      }
    }
  };

  const handleMallsRemove = (data: VoucherMallsRemove) => {
    if (data.voucherRemoveMalls.errors.length === 0) {
      closeModal();
      reset();
      if (assignMallShouldNotify) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Voucher Updated"
          })
        });
        refetch();
      }
      if (data.voucherRemoveMalls.voucher.type === "E_VOUCHER") {
        variantRefetch();
      } else {
        productRefetch();
      }
    } else {
      if (assignMallShouldNotify) {
        notify({
          status: "error",
          text: data.voucherRemoveMalls.errors[0].message
        });
      }
    }
  };

  const handleCustomersAdd = (data: VoucherCustomersAdd) => {
    if (data.voucherAddCustomers.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher Updated"
        })
      });
      customerRefetch();
    } else {
      notify({
        status: "error",
        text: data.voucherAddCustomers.errors[0].message
      });
    }
  };

  const handleCustomersRemove = (data: VoucherCustomersRemove) => {
    if (data.voucherRemoveCustomers.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Voucher Updated"
        })
      });
      customerRefetch();
    } else {
      notify({
        status: "error",
        text: data.voucherRemoveCustomers.errors[0].message
      });
    }
  };

  const handleVoucherAddBrandGroups = (data: VoucherAddBrandGroups) => {
    if (data.voucherAddBrandGroups.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Store assigned"
        })
      });
      storesRefetch();
    } else {
      notify({
        status: "error",
        text: data.voucherAddBrandGroups.errors[0].message
      });
    }
  };

  const handleVoucherTenantDelete = (data: VoucherTenantDelete) => {
    if (data.voucherTenantDelete.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Store removed"
        })
      });
      storesRefetch();
    } else {
      notify({
        status: "error",
        text: data.voucherTenantDelete.errors[0].message
      });
    }
  };

  const handleVoucherTenantUpdate = (data: VoucherTenantUpdate) => {
    if (data.voucherTenantUpdate.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Store updated successfully"
        })
      });
      storesRefetch();
    } else {
      notify({
        status: "error",
        text: data.voucherTenantUpdate.errors[0].message
      });
    }
  };

  const isBulkVoucher = maybe(() => data?.voucher?.group?.id);

  const canOpenBulkActionDialog = maybe(() => params.ids.length > 0);

  const currMalls = maybe(
    () => data.voucher.malls.edges.map(value => value.node.id),
    []
  );

  const {
    loadMore: loadMoreSellers,
    search: searchSellers,
    result: searchSellerOpts
  } = useBrandGroupSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      status: "ACT",
      malls: currMalls
    }
  });

  const sellers = maybe(
    () => searchSellerOpts?.data?.search?.edges?.map(edge => edge.node),
    []
  );
  const handleAssignMalls = (
    formData,
    voucher,
    voucherMallsAdd,
    voucherMallsRemove
  ) => {
    setAssignMallShouldNotify(false);
    const assignedMalls = maybe(() => voucher.malls.edges, []).map(
      mall => mall.node.id
    );

    const [newMalls, removedMalls] = [
      formData.filter(mall => !assignedMalls.includes(mall)),
      assignedMalls.filter(mall => !formData.includes(mall))
    ];

    return new Promise(async (resolve, reject) => {
      const errors = new Set();

      if (removedMalls.length) {
        const removeMallsResponse = await voucherMallsRemove({
          variables: {
            ...mallsPaginationState,
            id,
            input: {
              isAppliedToAllMalls: false,
              malls: removedMalls
            }
          }
        });

        if (removeMallsResponse.data.voucherRemoveMalls.errors.length) {
          removeMallsResponse.data.voucherRemoveMalls.errors.forEach(error => {
            errors.add(error.message);
          });
        }
      }

      if (newMalls.length) {
        const addMallsResponse = await voucherMallsAdd({
          variables: {
            ...paginationState,
            id,
            input: {
              isAppliedToAllMalls: true,
              malls: newMalls
            }
          }
        });

        if (addMallsResponse.data.voucherAddMalls.errors.length) {
          addMallsResponse.data.voucherAddMalls.errors.forEach(error => {
            errors.add(error.message);
          });
        }
      }

      if (errors.size) {
        reject(Array.from(errors).join(" "));
      }

      resolve("Voucher Updated");
    })
      .then(response => {
        notify({
          status: "success",
          text: response
        });

        refetch();
      })
      .catch(errors => {
        notify({
          status: "error",
          text: errors
        });
      })
      .finally(() => {
        setAssignMallShouldNotify(true);
      });
  };

  return (
    <TypedVoucherTenantUpdate onCompleted={handleVoucherTenantUpdate}>
      {(voucherTenantUpdate, voucherTenantUpdateOpts) => (
        <TypedVoucherTenantDelete onCompleted={handleVoucherTenantDelete}>
          {(voucherTenantDelete, voucherTenantDeleteOpts) => (
            <TypedVoucherAddBrandGroups
              onCompleted={handleVoucherAddBrandGroups}
            >
              {(voucherAddBrandGroups, voucherAddBrandGroupsOpts) => (
                <TypedVoucherCustomersRemove
                  onCompleted={handleCustomersRemove}
                >
                  {(voucherCustomersRemove, voucherCustomersRemoveOpts) => (
                    <TypedVoucherCustomersAdd onCompleted={handleCustomersAdd}>
                      {(voucherCustomersAdd, voucherCustomersAddOpts) => (
                        <TypedVoucherMallsRemove
                          onCompleted={handleMallsRemove}
                        >
                          {(voucherMallsRemove, voucherMallsRemoveOpts) => (
                            <TypedVoucherMallsAdd onCompleted={handleMallsAdd}>
                              {(voucherMallsAdd, voucherMallsAddOpts) => (
                                <TypedVoucherCataloguesRemove
                                  onCompleted={handleCatalogueRemove}
                                >
                                  {(
                                    voucherCataloguesRemove,
                                    voucherCataloguesRemoveOpts
                                  ) => (
                                    <TypedVoucherCataloguesAdd
                                      onCompleted={handleCatalogueAdd}
                                    >
                                      {(
                                        voucherCataloguesAdd,
                                        voucherCataloguesAddOpts
                                      ) => (
                                        <TypedVoucherUpdate
                                          onCompleted={handleVoucherUpdate}
                                        >
                                          {(
                                            voucherUpdate,
                                            voucherUpdateOpts
                                          ) => (
                                            <TypedUpdateVoucherStatus
                                              onCompleted={
                                                handleUpdateVoucherStatus
                                              }
                                            >
                                              {(
                                                updateVoucherStatus,
                                                updateVoucherStatusOpts
                                              ) => {
                                                // const mallsAssign = data?.voucher?.malls?.edges?.map(
                                                //   edge => edge.node
                                                // );
                                                const tabPageInfo =
                                                  params.activeTab ===
                                                  VoucherDetailsPageTab.categories
                                                    ? maybe(
                                                        () =>
                                                          data.voucher
                                                            .categories.pageInfo
                                                      )
                                                    : params.activeTab ===
                                                      VoucherDetailsPageTab.collections
                                                    ? maybe(
                                                        () =>
                                                          data.voucher
                                                            .collections
                                                            .pageInfo
                                                      )
                                                    : data &&
                                                      data.voucher &&
                                                      // data.voucher.type !== "E_VOUCHER" &&
                                                      // data.voucher.discountValueType !==
                                                      //   DiscountValueTypeEnum.PERCENTAGE
                                                      // ? maybe(
                                                      //     () =>
                                                      //       productData.voucher.products
                                                      //         .pageInfo
                                                      //   )
                                                      // :
                                                      maybe(
                                                        () =>
                                                          variantData.voucher
                                                            .productVariants
                                                            .pageInfo
                                                      );

                                                const handleCategoriesUnassign = (
                                                  ids: string[]
                                                ) =>
                                                  voucherCataloguesRemove({
                                                    variables: {
                                                      ...paginationState,
                                                      id,
                                                      input: {
                                                        categories: ids
                                                      }
                                                    }
                                                  });

                                                const handleCollectionsUnassign = (
                                                  ids: string[]
                                                ) =>
                                                  voucherCataloguesRemove({
                                                    variables: {
                                                      ...paginationState,
                                                      id,
                                                      input: {
                                                        collections: ids
                                                      }
                                                    }
                                                  });

                                                const handleProductsUnassign = (
                                                  ids: string[]
                                                ) => {
                                                  const input = {
                                                    productVariantsWithSubsidy: [],
                                                    product_variants: [],
                                                    products: []
                                                  };
                                                  input.product_variants = ids;
                                                  voucherCataloguesRemove({
                                                    variables: {
                                                      ...paginationState,
                                                      id,
                                                      input: {
                                                        ...input
                                                      }
                                                    }
                                                  });
                                                };

                                                const handleCustomersUnassign = (
                                                  ids: string[]
                                                ) => {
                                                  voucherCustomersRemove({
                                                    variables: {
                                                      ...customerPaginationState,
                                                      id,
                                                      input: {
                                                        customers: ids
                                                      }
                                                    }
                                                  });
                                                };

                                                const handleSubmit = async (
                                                  data: VoucherDetailsPageFormData
                                                ) => {
                                                  const isChanged =
                                                    currentCode !== data?.code;
                                                  const result = await voucherUpdate(
                                                    {
                                                      variables: {
                                                        id,
                                                        input: {
                                                          ...(isChanged && {
                                                            code: data.code
                                                          }),
                                                          applyOncePerCustomer:
                                                            data.applyOncePerCustomer,
                                                          applyOncePerOrder:
                                                            data.applyOncePerOrder,
                                                          deliveryTypes:
                                                            data.deliveryType,
                                                          description:
                                                            data.description,
                                                          discountValue:
                                                            data.discountType.toString() ===
                                                            "SHIPPING"
                                                              ? 100
                                                              : decimal(
                                                                  data.value
                                                                ),
                                                          discountValueType:
                                                            data.discountType.toString() ===
                                                            "SHIPPING"
                                                              ? DiscountValueTypeEnum.PERCENTAGE
                                                              : data.discountType.toString() ===
                                                                VoucherDiscountType.PERCENTAGE_AND_CAPPED
                                                              ? DiscountValueTypeEnum.PERCENTAGE
                                                              : data.discountType,
                                                          endDate: data.hasEndDate
                                                            ? changeTimeZone(
                                                                data.endDate,
                                                                data.endTime
                                                              )
                                                            : null,
                                                          isAppliedOnEligibleItems:
                                                            data.isAppliedOnEligibleItems,
                                                          isAppliedToAllMalls:
                                                            data.isAppliedToAllMalls,
                                                          isHidden: data.isSpecificCustomer
                                                            ? false
                                                            : data.isHidden,
                                                          isLimitToNewCustomer: data.isSpecificCustomer
                                                            ? false
                                                            : data.applyToNewCustomer,

                                                          isMinEligibleOnly:
                                                            data.isMinEligibleOnly,
                                                          isSpecificCustomer:
                                                            data.isSpecificCustomer,
                                                          maxDiscountValue: data.maxDiscountValue
                                                            ? decimal(
                                                                data.maxDiscountValue
                                                              )
                                                            : null,

                                                          minAmountSpent:
                                                            data.requirementsPicker !==
                                                            RequirementsPicker.ORDER
                                                              ? 0
                                                              : parseFloat(
                                                                  data.minSpent
                                                                ),
                                                          minCheckoutItemsQuantity:
                                                            data.requirementsPicker !==
                                                            RequirementsPicker.ITEM
                                                              ? 0
                                                              : parseFloat(
                                                                  data.minCheckoutItemsQuantity
                                                                ),
                                                          // paymentMethod: data.paymentType,
                                                          minTenants:
                                                            data.minTenants,
                                                          smopDiscountShare:
                                                            data.discountType.toString() ===
                                                            "SHIPPING"
                                                              ? 0
                                                              : data.smopDiscountShare,
                                                          startDate: changeTimeZone(
                                                            data.startDate,
                                                            data.startTime
                                                          ),
                                                          tenantDiscountShare:
                                                            data.discountType.toString() ===
                                                            "SHIPPING"
                                                              ? 0
                                                              : data.tenantDiscountShare,
                                                          type:
                                                            data.discountType.toString() ===
                                                            "SHIPPING"
                                                              ? VoucherTypeEnum.SHIPPING
                                                              : data.type,
                                                          usageLimit: data.hasUsageLimit
                                                            ? parseInt(
                                                                data.usageLimit,
                                                                10
                                                              )
                                                            : null,
                                                          verticalType:
                                                            data.verticalType
                                                        }
                                                      }
                                                    }
                                                  );

                                                  voucherConditionUpdate(
                                                    voucherDetails
                                                  );

                                                  return result.data
                                                    .voucherUpdate.errors;
                                                };

                                                const {
                                                  loadNextPage
                                                } = paginate(
                                                  tabPageInfo,
                                                  paginationState,
                                                  params
                                                );

                                                const {
                                                  loadNextMallsPage,
                                                  loadPreviousMallsPage,
                                                  pageMallsInfo
                                                } = mallsPaginate(
                                                  tabPageInfo,
                                                  mallsPaginationState,
                                                  params,
                                                  navigate
                                                );

                                                const {
                                                  loadNextProductPage,
                                                  loadPreviousProductPage,
                                                  pageProductInfo
                                                } = productPaginate(
                                                  tabPageInfo,
                                                  productPaginationState,
                                                  params,
                                                  navigate
                                                );

                                                const {
                                                  loadNextCustomerPage,
                                                  loadPreviousCustomerPage,
                                                  pageCustomerInfo
                                                } = customerPaginate(
                                                  maybe(
                                                    () =>
                                                      customerData.voucher
                                                        .eligibleCustomers
                                                        .pageInfo
                                                  ),
                                                  customerPaginationState,
                                                  params,
                                                  navigate
                                                );

                                                return (
                                                  <>
                                                    <WindowTitle
                                                      title={intl.formatMessage(
                                                        sectionNames.vouchers
                                                      )}
                                                    />
                                                    <VoucherDetailsPage
                                                      setStoreInfo={value => {
                                                        setStoreInfo(value);
                                                      }}
                                                      assignedTenants={maybe(
                                                        () =>
                                                          storesData?.voucher
                                                      )}
                                                      isBulkVoucher={
                                                        isBulkVoucher
                                                      }
                                                      onFetch={
                                                        setvoucherProductQuery
                                                      }
                                                      assignedProducts={maybe(
                                                        () =>
                                                          productData.voucher
                                                            ?.products
                                                      )}
                                                      assignedVariants={maybe(
                                                        () =>
                                                          variantData.voucher
                                                            ?.productVariants
                                                      )}
                                                      defaultCurrency={maybe(
                                                        () =>
                                                          shop.defaultCurrency,
                                                        "PHP"
                                                      )}
                                                      voucher={maybe(
                                                        () => data.voucher
                                                      )}
                                                      disabled={
                                                        loading ||
                                                        voucherCataloguesRemoveOpts.loading ||
                                                        voucherMallsRemoveOpts.loading ||
                                                        voucherCustomersRemoveOpts.loading ||
                                                        voucherTenantDeleteOpts.loading
                                                      }
                                                      eligibleCustomers={maybe(
                                                        () =>
                                                          customerData.voucher
                                                            ?.eligibleCustomers
                                                      )}
                                                      errors={
                                                        voucherUpdateOpts.data
                                                          ?.voucherUpdate
                                                          .errors || []
                                                      }
                                                      customerListToolbar={
                                                        <Button
                                                          color="primary"
                                                          onClick={() =>
                                                            openModal(
                                                              "unassign-customer",
                                                              {
                                                                ids: listElements
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <FormattedMessage
                                                            defaultMessage="Unassign"
                                                            description="unassign product from voucher, button"
                                                            id="voucherDetailsUnassignProduct"
                                                          />
                                                        </Button>
                                                      }
                                                      customerPageInfo={
                                                        pageCustomerInfo
                                                      }
                                                      pageInfo={pageMallsInfo}
                                                      productPageInfo={
                                                        pageProductInfo
                                                      }
                                                      onCustomerAssign={() =>
                                                        openModal(
                                                          "assign-customers"
                                                        )
                                                      }
                                                      onCustomerUnassign={customerId =>
                                                        voucherCustomersRemove({
                                                          variables: {
                                                            ...customerPaginationState,
                                                            id,
                                                            input: {
                                                              customers: [
                                                                customerId
                                                              ]
                                                            }
                                                          }
                                                        })
                                                      }
                                                      onNextCustomerPage={
                                                        loadNextCustomerPage
                                                      }
                                                      onNextProductPage={
                                                        loadNextProductPage
                                                      }
                                                      onPreviousCustomerPage={
                                                        loadPreviousCustomerPage
                                                      }
                                                      onPreviousProductPage={
                                                        loadPreviousProductPage
                                                      }
                                                      onNextPage={
                                                        loadNextMallsPage
                                                      }
                                                      onPreviousPage={
                                                        loadPreviousMallsPage
                                                      }
                                                      onMallAssign={() =>
                                                        openModal("assign-mall")
                                                      }
                                                      onMallUnassign={malls => {
                                                        let isAllMalls = false;
                                                        if (
                                                          data.voucher.malls
                                                            .totalCount === 1
                                                        ) {
                                                          isAllMalls = true;
                                                        }
                                                        voucherMallsRemove({
                                                          variables: {
                                                            ...mallsPaginationState,
                                                            id,
                                                            input: {
                                                              isAppliedToAllMalls: isAllMalls,
                                                              malls: [malls]
                                                            }
                                                          }
                                                        });
                                                      }}
                                                      // onCategoryUnassign={categoryId =>
                                                      //   voucherCataloguesRemove({
                                                      //     variables: {
                                                      //       ...paginationState,
                                                      //       id,
                                                      //       input: {
                                                      //         categories: [categoryId]
                                                      //       }
                                                      //     }
                                                      //   })
                                                      // }
                                                      // onCollectionClick={id => () =>
                                                      //   navigate(collectionUrl(id))}
                                                      // onCategoryAssign={() =>
                                                      //   openModal("assign-category")
                                                      // }
                                                      // onCategoryClick={id => () =>
                                                      //   navigate(categoryUrl(id))}
                                                      // onCollectionAssign={() =>
                                                      //   openModal("assign-collection")
                                                      // }
                                                      // onCollectionUnassign={collectionId =>
                                                      //   voucherCataloguesRemove({
                                                      //     variables: {
                                                      //       ...paginationState,
                                                      //       id,
                                                      //       input: {
                                                      //         collections: [collectionId]
                                                      //       }
                                                      //     }
                                                      //   })
                                                      // }
                                                      onProductAssign={() => {
                                                        // if (
                                                        //   data.voucher.type ===
                                                        //     "E_VOUCHER" ||
                                                        //   data.voucher.discountValueType ===
                                                        //     DiscountValueTypeEnum.PERCENTAGE
                                                        // ) {
                                                        // openModal(
                                                        //   "assign-product-e-voucher"
                                                        // );
                                                        navigate(
                                                          voucherUrl(id, {
                                                            action:
                                                              "assign-product-e-voucher"
                                                          })
                                                        );
                                                        // } else {
                                                        //   openModal("assign-product");
                                                        // }
                                                      }}
                                                      onStoreAssign={() =>
                                                        openModal(
                                                          "assign-stores"
                                                        )
                                                      }
                                                      onStoreUnassign={tenantID => {
                                                        voucherTenantDelete({
                                                          variables: {
                                                            id: tenantID
                                                          }
                                                        });
                                                      }}
                                                      onStoreEdit={() =>
                                                        openModal("edit-store")
                                                      }
                                                      onProductUnassign={productId => {
                                                        const input = {
                                                          productVariantsWithSubsidy: [],
                                                          product_variants: [],
                                                          products: []
                                                        };
                                                        input.product_variants = [
                                                          productId
                                                        ];
                                                        voucherCataloguesRemove(
                                                          {
                                                            variables: {
                                                              ...DEFAULT_INITIAL_SEARCH_PRODUCT_DATA,
                                                              id,
                                                              input: {
                                                                ...input
                                                              }
                                                            }
                                                          }
                                                        );
                                                      }}
                                                      onProductClick={() => () =>
                                                        undefined}
                                                      // onProductClick={id => () => {
                                                      //   if (
                                                      //     data &&
                                                      //     data.voucher &&
                                                      //     data.voucher.type !== "E_VOUCHER"
                                                      //   ) {
                                                      //     navigate(productUrl(id));
                                                      //   }
                                                      // }}
                                                      activeTab={
                                                        params.activeTab
                                                      }
                                                      onBack={
                                                        isBulkVoucher
                                                          ? () =>
                                                              navigate(
                                                                bulkVoucherListUrl(
                                                                  isBulkVoucher
                                                                )
                                                              )
                                                          : () =>
                                                              navigate(
                                                                voucherListUrl()
                                                              )
                                                      }
                                                      onTabClick={changeTab}
                                                      onSubmit={handleSubmit}
                                                      onRemove={() =>
                                                        openModal("status")
                                                      }
                                                      saveButtonBarState={
                                                        voucherUpdateOpts.status
                                                      }
                                                      // categoryListToolbar={
                                                      //   <Button
                                                      //     color="primary"
                                                      //     onClick={() =>
                                                      //       openModal("unassign-category", {
                                                      //         ids: listElements
                                                      //       })
                                                      //     }
                                                      //   >
                                                      //     <FormattedMessage
                                                      //       defaultMessage="Unassign"
                                                      //       description="unassign category from voucher, button"
                                                      //       id="voucherDetailsUnassignCategory"
                                                      //     />
                                                      //   </Button>
                                                      // }
                                                      // collectionListToolbar={
                                                      //   <Button
                                                      //     color="primary"
                                                      //     onClick={() =>
                                                      //       openModal("unassign-collection", {
                                                      //         ids: listElements
                                                      //       })
                                                      //     }
                                                      //   >
                                                      //     <FormattedMessage
                                                      //       defaultMessage="Unassign"
                                                      //       description="unassign collection from voucher, button"
                                                      //       id="voucherDetailsUnassignCollection"
                                                      //     />
                                                      //   </Button>
                                                      // }
                                                      productListToolbar={
                                                        <Button
                                                          id="voucherProductUnassignBtn"
                                                          color="primary"
                                                          onClick={() =>
                                                            openModal(
                                                              "unassign-product",
                                                              {
                                                                after: null,
                                                                ids: listElements
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <FormattedMessage
                                                            defaultMessage="Unassign"
                                                            description="unassign product from voucher, button"
                                                            id="voucherDetailsUnassignProduct"
                                                          />
                                                        </Button>
                                                      }
                                                      isChecked={isSelected}
                                                      selected={
                                                        listElements.length
                                                      }
                                                      toggle={toggle}
                                                      toggleAll={toggleAll}
                                                      voucherBulkCreate={
                                                        undefined
                                                      }
                                                      voucherLimitState={
                                                        voucherLimitState
                                                      }
                                                      voucherLimitDispatcher={
                                                        voucherLimitDispatcher
                                                      }
                                                    />
                                                    {/* <AssignCategoriesDialog
                                              categories={maybe(() =>
                                                searchCategoriesOpts.data.search.edges
                                                  .map(edge => edge.node)
                                                  .filter(
                                                    suggestedCategory => suggestedCategory.id
                                                  )
                                              )}
                                              confirmButtonState={
                                                voucherCataloguesAddOpts.status
                                              }
                                              hasMore={
                                                searchCategoriesOpts.data?.search.pageInfo
                                                  .hasNextPage
                                              }
                                              open={params.action === "assign-category"}
                                              onFetch={searchCategories}
                                              onFetchMore={loadMoreCategories}
                                              loading={searchCategoriesOpts.loading}
                                              onClose={closeModal}
                                              onSubmit={categories =>
                                                voucherCataloguesAdd({
                                                  variables: {
                                                    ...paginationState,
                                                    id,
                                                    input: {
                                                      categories
                                                    }
                                                  }
                                                })
                                              }
                                            />
                                            <AssignCollectionDialog
                                              collections={maybe(() =>
                                                searchCollectionsOpts.data.search.edges
                                                  .map(edge => edge.node)
                                                  .filter(
                                                    suggestedCategory => suggestedCategory.id
                                                  )
                                              )}
                                              confirmButtonState={
                                                voucherCataloguesAddOpts.status
                                              }
                                              hasMore={
                                                searchCollectionsOpts.data?.search.pageInfo
                                                  .hasNextPage
                                              }
                                              open={params.action === "assign-collection"}
                                              onFetch={searchCollections}
                                              onFetchMore={loadMoreCollections}
                                              loading={searchCollectionsOpts.loading}
                                              onClose={closeModal}
                                              onSubmit={collections =>
                                                voucherCataloguesAdd({
                                                  variables: {
                                                    ...paginationState,
                                                    id,
                                                    input: {
                                                      collections
                                                    }
                                                  }
                                                })
                                              }
                                            /> */}
                                                    <AssignMallDialog
                                                      confirmButtonState={
                                                        voucherMallsAddOpts.status
                                                      }
                                                      field="voucher"
                                                      malls={maybe(() =>
                                                        searchMallsOpts.data.search.edges
                                                          .map(
                                                            edge => edge.node
                                                          )
                                                          .filter(
                                                            suggestedMall =>
                                                              suggestedMall.id
                                                          )
                                                      )}
                                                      onClose={() =>
                                                        navigate(voucherUrl(id))
                                                      }
                                                      onConfirm={formData =>
                                                        handleAssignMalls(
                                                          formData,
                                                          data.voucher,
                                                          voucherMallsAdd,
                                                          voucherMallsRemove
                                                        )
                                                      }
                                                      onFetch={searchMall}
                                                      open={
                                                        params.action ===
                                                        "assign-mall"
                                                      }
                                                      initial={maybe(
                                                        () =>
                                                          data.voucher?.malls
                                                            .edges
                                                      )}
                                                      fetchMoreMalls={{
                                                        hasMore: maybe(
                                                          () =>
                                                            searchMallsOpts &&
                                                            searchMallsOpts.data &&
                                                            searchMallsOpts.data
                                                              .search.pageInfo
                                                              .hasNextPage
                                                        ),
                                                        loading:
                                                          searchMallsOpts.loading,
                                                        onFetchMore: loadMoreMalls
                                                      }}
                                                      loading={
                                                        searchMallsOpts.loading
                                                      }
                                                      hasMore={
                                                        searchMallsOpts?.data
                                                          ?.search?.pageInfo
                                                          ?.hasNextPage
                                                      }
                                                      onFetchMore={
                                                        loadMoreMalls
                                                      }
                                                    />
                                                    {/* <DiscountCountrySelectDialog
                                              confirmButtonState={voucherUpdateOpts.status}
                                              countries={maybe(() => shop.countries, [])}
                                              onClose={() => navigate(voucherUrl(id))}
                                              onConfirm={formData =>
                                                voucherUpdate({
                                                  variables: {
                                                    id,
                                                    input: {
                                                      countries: formData.countries,
                                                      isAppliedToAllMalls: false
                                                    }
                                                  }
                                                })
                                              }
                                              open={params.action === "assign-mall"}
                                              initial={maybe(
                                                () =>
                                                  data.voucher.countries.map(
                                                    country => country.code
                                                  ),
                                                []
                                              )}
                                            /> */}
                                                    <AssignDiscountProductDialog
                                                      brands={
                                                        sellerBrandChoices
                                                      }
                                                      fetchBrands={query =>
                                                        searchBrands(query)
                                                      }
                                                      fetchMoreBrands={{
                                                        hasMore: maybe(
                                                          () =>
                                                            brandsQueryData &&
                                                            brandsQueryData.data &&
                                                            brandsQueryData.data
                                                              .search.pageInfo
                                                              .hasNextPage
                                                        ),
                                                        loading:
                                                          brandsQueryData.loading,
                                                        onFetchMore: loadMoreBrand
                                                      }}
                                                      confirmButtonState={
                                                        voucherCataloguesAddOpts.status
                                                      }
                                                      hasMore={
                                                        searchProductsOpts.data
                                                          ?.search?.pageInfo
                                                          .hasNextPage
                                                      }
                                                      open={
                                                        params.action ===
                                                        "assign-product"
                                                      }
                                                      onFetch={searchProducts}
                                                      onFetchMore={
                                                        loadMoreProducts
                                                      }
                                                      loading={
                                                        searchProductsOpts.loading
                                                      }
                                                      // onClose={closeModal}
                                                      onClose={() =>
                                                        navigate(voucherUrl(id))
                                                      }
                                                      onSelectBrand={value =>
                                                        setCurrentBrand(value)
                                                      }
                                                      onSubmit={products =>
                                                        voucherCataloguesAdd({
                                                          variables: {
                                                            ...paginationState,
                                                            id,
                                                            input: {
                                                              products: products.map(
                                                                product =>
                                                                  product.id
                                                              )
                                                            }
                                                          }
                                                        })
                                                      }
                                                      products={maybe(() =>
                                                        searchProductsOpts.data.search.edges
                                                          .map(
                                                            edge => edge.node
                                                          )
                                                          .filter(
                                                            suggestedProduct =>
                                                              suggestedProduct.id
                                                          )
                                                      )}
                                                    />
                                                    {params.action ===
                                                      "assign-product-e-voucher" && (
                                                      <AssignProductSubsidyDialog
                                                        brands={
                                                          sellerBrandChoices
                                                        }
                                                        fetchBrands={query =>
                                                          searchBrands(query)
                                                        }
                                                        fetchMoreBrands={{
                                                          hasMore: maybe(
                                                            () =>
                                                              brandsQueryData &&
                                                              brandsQueryData.data &&
                                                              brandsQueryData
                                                                .data.search
                                                                .pageInfo
                                                                .hasNextPage
                                                          ),
                                                          loading:
                                                            brandsQueryData.loading,
                                                          onFetchMore: loadMoreBrand
                                                        }}
                                                        confirmButtonState={
                                                          voucherCataloguesAddOpts.status
                                                        }
                                                        hasMore={
                                                          searchProductsOpts
                                                            .data?.search
                                                            ?.pageInfo
                                                            .hasNextPage
                                                        }
                                                        open={
                                                          params.action ===
                                                          "assign-product-e-voucher"
                                                        }
                                                        onFetch={searchProducts}
                                                        onFetchMore={
                                                          loadMoreProducts
                                                        }
                                                        onSelectBrand={value =>
                                                          setCurrentBrand(value)
                                                        }
                                                        loading={
                                                          searchProductsOpts.loading
                                                        }
                                                        onClose={() => {
                                                          setCurrentBrand(null);
                                                          navigate(
                                                            voucherUrl(id)
                                                          );
                                                        }}
                                                        onSubmit={products => {
                                                          voucherCataloguesAdd({
                                                            variables: {
                                                              // ...paginationState,
                                                              first: 20,
                                                              id,
                                                              input: products
                                                            }
                                                          });
                                                        }}
                                                        products={maybe(() =>
                                                          searchProductsOpts.data.search.edges
                                                            .map(
                                                              edge => edge.node
                                                            )
                                                            .filter(
                                                              suggestedProduct =>
                                                                suggestedProduct.id
                                                            )
                                                        )}
                                                        variants={maybe(
                                                          () =>
                                                            variantData.voucher
                                                              .productVariants
                                                        )}
                                                        onFetchMoreVariants={
                                                          loadNextPage
                                                        }
                                                      />
                                                    )}
                                                    <BrandGroupDialog
                                                      confirmButtonState={
                                                        voucherAddBrandGroupsOpts.status
                                                      }
                                                      isNationwideVoucher={
                                                        data?.voucher
                                                          ?.verticalType ===
                                                        "SM_FULFILLED"
                                                      }
                                                      sellers={sellers}
                                                      fetchMoreSellers={{
                                                        hasMore: maybe(
                                                          () =>
                                                            searchSellerOpts
                                                              ?.data?.search
                                                              ?.pageInfo
                                                              ?.hasNextPage
                                                        ),
                                                        loading:
                                                          searchSellerOpts?.loading,
                                                        onFetchMore: loadMoreSellers
                                                      }}
                                                      open={
                                                        params.action ===
                                                        "assign-stores"
                                                      }
                                                      onClose={closeModal}
                                                      fetchSellers={
                                                        searchSellers
                                                      }
                                                      data={data}
                                                      onSubmit={payload => {
                                                        voucherAddBrandGroups({
                                                          variables: {
                                                            id,
                                                            input: {
                                                              brandGroups:
                                                                payload.brandGroups,
                                                              isAppliedToAllBrandGroups:
                                                                payload.isAppliedToAllBrandGroups,
                                                              smoDiscountShare:
                                                                payload.smoDiscountShare,
                                                              tenantDiscountShare:
                                                                payload.tenantDiscountShare
                                                            }
                                                          }
                                                        });
                                                      }}
                                                      tenants={maybe(
                                                        () =>
                                                          storesData?.voucher
                                                      )}
                                                    />
                                                    <BrandSingleEditDialog
                                                      confirmButtonState={
                                                        voucherTenantUpdateOpts.status
                                                      }
                                                      eligibleStoreInfo={
                                                        eligibleStoreInfo
                                                      }
                                                      open={
                                                        params.action ===
                                                        "edit-store"
                                                      }
                                                      onClose={closeModal}
                                                      onSubmit={payload =>
                                                        voucherTenantUpdate({
                                                          variables: {
                                                            id: payload.id,
                                                            input: {
                                                              smoDiscountShare:
                                                                payload.smoDiscountShare,
                                                              tenantDiscountShare:
                                                                payload.tenantDiscountShare
                                                            }
                                                          }
                                                        })
                                                      }
                                                    />
                                                    <AssignCustomerDialog
                                                      confirmButtonState={
                                                        voucherCustomersAddOpts.status
                                                      }
                                                      customers={maybe(
                                                        () =>
                                                          searchCustomerOpts.data.search.edges
                                                            .map(
                                                              edge => edge.node
                                                            )
                                                            .filter(
                                                              suggestedCustomer =>
                                                                suggestedCustomer.id
                                                            ),
                                                        []
                                                      )}
                                                      hasMore={maybe(
                                                        () =>
                                                          searchCustomerOpts
                                                            .data?.search
                                                            .pageInfo
                                                            .hasNextPage
                                                      )}
                                                      loading={
                                                        searchCustomerOpts.loading
                                                      }
                                                      onClose={closeModal}
                                                      onConfirm={params =>
                                                        voucherCustomersAdd({
                                                          variables: {
                                                            ...paginationState,
                                                            id,
                                                            input: {
                                                              customers:
                                                                params.customers
                                                            }
                                                          }
                                                        })
                                                      }
                                                      onFetch={searchCustomers}
                                                      onFetchMore={
                                                        loadMoreCustomers
                                                      }
                                                      open={
                                                        params.action ===
                                                        "assign-customers"
                                                      }
                                                      initial={maybe(
                                                        () =>
                                                          customerData.voucher
                                                            .eligibleCustomers
                                                            .edges,
                                                        []
                                                      )}
                                                    />
                                                    <ActionDialog
                                                      open={
                                                        params.action ===
                                                          "unassign-category" &&
                                                        canOpenBulkActionDialog
                                                      }
                                                      title={intl.formatMessage(
                                                        {
                                                          defaultMessage:
                                                            "Unassign Categories From Voucher",
                                                          description:
                                                            "dialog header"
                                                        }
                                                      )}
                                                      confirmButtonState={
                                                        voucherCataloguesRemoveOpts.status
                                                      }
                                                      onClose={closeModal}
                                                      onConfirm={() =>
                                                        handleCategoriesUnassign(
                                                          params.ids
                                                        )
                                                      }
                                                    >
                                                      {canOpenBulkActionDialog && (
                                                        <DialogContentText>
                                                          <FormattedMessage
                                                            defaultMessage="{counter,plural,one{Are you sure you want to unassign this category?} other{Are you sure you want to unassign {displayQuantity} categories?}}"
                                                            description="dialog content"
                                                            values={{
                                                              counter:
                                                                params.ids
                                                                  .length,
                                                              displayQuantity: (
                                                                <strong>
                                                                  {
                                                                    params.ids
                                                                      .length
                                                                  }
                                                                </strong>
                                                              )
                                                            }}
                                                          />
                                                        </DialogContentText>
                                                      )}
                                                    </ActionDialog>
                                                    <ActionDialog
                                                      open={
                                                        params.action ===
                                                          "unassign-collection" &&
                                                        canOpenBulkActionDialog
                                                      }
                                                      title={intl.formatMessage(
                                                        {
                                                          defaultMessage:
                                                            "Unassign Collections From Voucher",
                                                          description:
                                                            "dialog header"
                                                        }
                                                      )}
                                                      confirmButtonState={
                                                        voucherCataloguesRemoveOpts.status
                                                      }
                                                      onClose={closeModal}
                                                      onConfirm={() =>
                                                        handleCollectionsUnassign(
                                                          params.ids
                                                        )
                                                      }
                                                    >
                                                      {canOpenBulkActionDialog && (
                                                        <DialogContentText>
                                                          <FormattedMessage
                                                            defaultMessage="{counter,plural,one{Are you sure you want to unassign this collection?} other{Are you sure you want to unassign {displayQuantity} collections?}}"
                                                            description="dialog content"
                                                            values={{
                                                              counter:
                                                                params.ids
                                                                  .length,
                                                              displayQuantity: (
                                                                <strong>
                                                                  {
                                                                    params.ids
                                                                      .length
                                                                  }
                                                                </strong>
                                                              )
                                                            }}
                                                          />
                                                        </DialogContentText>
                                                      )}
                                                    </ActionDialog>
                                                    <ActionDialog
                                                      open={
                                                        params.action ===
                                                          "unassign-product" &&
                                                        canOpenBulkActionDialog
                                                      }
                                                      title={intl.formatMessage(
                                                        {
                                                          defaultMessage:
                                                            "Unassign Products From Voucher",
                                                          description:
                                                            "dialog header"
                                                        }
                                                      )}
                                                      confirmButtonState={
                                                        voucherCataloguesRemoveOpts.status
                                                      }
                                                      onClose={closeModal}
                                                      onConfirm={() =>
                                                        handleProductsUnassign(
                                                          params.ids
                                                        )
                                                      }
                                                    >
                                                      {canOpenBulkActionDialog && (
                                                        <DialogContentText>
                                                          <FormattedMessage
                                                            defaultMessage="{counter,plural,one{Are you sure you want to unassign this product?} other{Are you sure you want to unassign {displayQuantity} products?}}"
                                                            description="dialog content"
                                                            values={{
                                                              counter:
                                                                params.ids
                                                                  .length,
                                                              displayQuantity: (
                                                                <strong>
                                                                  {
                                                                    params.ids
                                                                      .length
                                                                  }
                                                                </strong>
                                                              )
                                                            }}
                                                          />
                                                        </DialogContentText>
                                                      )}
                                                    </ActionDialog>
                                                    <ActionDialog
                                                      open={
                                                        params.action ===
                                                          "unassign-customer" &&
                                                        canOpenBulkActionDialog
                                                      }
                                                      title={intl.formatMessage(
                                                        {
                                                          defaultMessage:
                                                            "Unassign Eligible Customers From Voucher",
                                                          description:
                                                            "dialog header"
                                                        }
                                                      )}
                                                      confirmButtonState={
                                                        voucherCustomersRemoveOpts.status
                                                      }
                                                      onClose={closeModal}
                                                      onConfirm={() =>
                                                        handleCustomersUnassign(
                                                          params.ids
                                                        )
                                                      }
                                                    >
                                                      {canOpenBulkActionDialog && (
                                                        <DialogContentText>
                                                          <FormattedMessage
                                                            defaultMessage="{counter,plural,one{Are you sure you want to unassign this customer?} other{Are you sure you want to unassign {displayQuantity} customers?}}"
                                                            description="dialog content"
                                                            values={{
                                                              counter:
                                                                params.ids
                                                                  .length,
                                                              displayQuantity: (
                                                                <strong>
                                                                  {
                                                                    params.ids
                                                                      .length
                                                                  }
                                                                </strong>
                                                              )
                                                            }}
                                                          />
                                                        </DialogContentText>
                                                      )}
                                                    </ActionDialog>
                                                    <ActionDialog
                                                      open={
                                                        params.action ===
                                                        "status"
                                                      }
                                                      title={intl.formatMessage(
                                                        {
                                                          defaultMessage:
                                                            "Deactivate Voucher",
                                                          description:
                                                            "dialog header"
                                                        }
                                                      )}
                                                      confirmButtonState={
                                                        updateVoucherStatusOpts.status
                                                      }
                                                      onClose={closeModal}
                                                      variant="delete"
                                                      confirmButtonLabel="Deactivate"
                                                      onConfirm={() =>
                                                        updateVoucherStatus({
                                                          variables: {
                                                            id,
                                                            status:
                                                              DiscountStatusEnum.INACTIVE
                                                          }
                                                        })
                                                      }
                                                    >
                                                      <DialogContentText>
                                                        <FormattedMessage
                                                          defaultMessage="Are you sure you want to deactivate {voucherCode}?"
                                                          description="dialog content"
                                                          values={{
                                                            voucherCode: (
                                                              <strong>
                                                                {maybe(
                                                                  () =>
                                                                    data.voucher
                                                                      .code,
                                                                  "..."
                                                                )}
                                                              </strong>
                                                            )
                                                          }}
                                                        />
                                                      </DialogContentText>
                                                    </ActionDialog>
                                                  </>
                                                );
                                              }}
                                            </TypedUpdateVoucherStatus>
                                          )}
                                        </TypedVoucherUpdate>
                                      )}
                                    </TypedVoucherCataloguesAdd>
                                  )}
                                </TypedVoucherCataloguesRemove>
                              )}
                            </TypedVoucherMallsAdd>
                          )}
                        </TypedVoucherMallsRemove>
                      )}
                    </TypedVoucherCustomersAdd>
                  )}
                </TypedVoucherCustomersRemove>
              )}
            </TypedVoucherAddBrandGroups>
          )}
        </TypedVoucherTenantDelete>
      )}
    </TypedVoucherTenantUpdate>
  );
};
export default VoucherDetails;
